document.addEventListener('bundler:total_cart_values', renderCartPriceWithBundler, false);

async function renderCartPriceWithBundler() {
  this.sleep = async function (time) {
    await new Promise((resolve) => setTimeout(resolve, time));
  };

  this.init = async () => {
    this.wrapper = document.querySelector('.totals__total-value');
    if (this.wrapper && !this.wrapper.dataset.classes) {
      this.wrapper.dataset.classes = [...this.wrapper.querySelector('p').classList];
    }
  };

  this.changeStyle = async () => {
    await this.init();

    const classList = this.wrapper.dataset.classes.split(',');
    const origPrice = this.wrapper.querySelector('.bndlr-cart-orig-price');
    const discountPrice = this.wrapper.querySelector('.bndlr-cart-discount-value');
    const discountedPrice = this.wrapper.querySelector('.bndlr-cart-discounted-value');

    origPrice.classList.add('tw-line-through', 'tw-opacity-80', 'mb-0');

    if (classList.includes('h6')) {
      origPrice.classList.add('tw-text-body-large');
      discountPrice.classList.add('tw-text-body-large');
    } else {
      origPrice.classList.add('h6');
      discountPrice.classList.add('h6');
    }

    discountPrice.classList.add('mb-0');
    discountedPrice.classList.add(...classList);

    const currencyIsoCode = this.wrapper.dataset.isoCode;
    if (currencyIsoCode && !origPrice.textContent.includes(currencyIsoCode)) {
      origPrice.textContent = `${origPrice.textContent} ${currencyIsoCode}`;
      discountPrice.textContent = `${discountPrice.textContent} ${currencyIsoCode}`;
      discountedPrice.textContent = `${discountedPrice.textContent} ${currencyIsoCode}`;
    }
  };

  this.main = async () => {
    await this.init();
    this.counter = (this.counter || 0) + 1;
    if (this.counter > 1000) return;
    await this.sleep(10);

    if (this.wrapper) {
      if (!this.wrapper.querySelector('.bndlr-cart-orig-price')) {
        await this.main();
      } else {
        await this.changeStyle();
      }
    }
  };

  this.main();
}

document.addEventListener('bundler:bundle_widget_created', function () {
  if (!window.bndlr) return;
  const bundles = window.bndlr.getBundles();
  const bundlerWidgetElements = document.querySelectorAll('#bundler-target-element');

  bundlerWidgetElements.forEach((bundlerWidgetElement) => {
    const bundleKey = bundlerWidgetElement.querySelector('[data-bundle]').dataset.bundle;
    const bundle = bundles.find((b) => b.id === +bundleKey);
    if (!bundle) return;

    const productFetchPromises = Object.values(bundle.products).map((product) => {
      return fetch(`/products/${product.handle}.js`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to check bundle for excluded products. Product: ${product.handle}`);
          }
          return response.json();
        })
        .then((productData) => {
          const bundleVariantIds = Object.keys(product.variants);
          const bundleProductVariants = productData.variants.filter((variant) =>
            bundleVariantIds.includes(String(variant.id)),
          );
          return bundleProductVariants.some((variant) => Number(variant.price) === 0);
        })
        .catch((error) => {
          console.error('Error fetching product:', product.handle, error);
          return false;
        });
    });

    Promise.all(productFetchPromises).then((results) => {
      if (results.includes(true)) {
        bundlerWidgetElement.closest('.product-info__block').hidden = true;
      }
    });
  });
});

document.addEventListener('bundler:bundle_widget_created', function () {
  const titles = document.querySelectorAll('.bndlr-bundle-title');
  const descriptions = document.querySelectorAll('.bndlr-bundle-description');
  const atcButtons = document.querySelectorAll('.bndlr-add-to-cart');
  const warnings = document.querySelectorAll('.bndlr-bundle-checkout-warning');

  const closeButton = document.querySelector('.bundles-bundler-hop-close-offer');
  const chekoutButton = document.querySelector('.bundles-bundler-hop-button-to-checkout');
  if (closeButton) closeButton.classList.add('btn', 'btn--secondary');
  if (chekoutButton) chekoutButton.classList.add('btn', 'btn--primary');

  const products = document.querySelectorAll('.bndlr-product');

  titles.forEach((title) => {
    title.classList.add('h4');
  });

  descriptions.forEach((description) => {
    description.classList.add('tw-text-body-large');
  });

  warnings.forEach((warning) => {
    warning.classList.add('tw-text-body-medium');
  });

  atcButtons.forEach((button) => {
    button.classList.add('btn', 'btn--secondary', 'btn--lg');
    button.addEventListener('click', function () {
      button.classList.add('active');
    });
  });

  products.forEach((product) => {
    const title = product.querySelector('.bndlr-product-title');
    if (title) title.classList.add('h6');
  });
});
